<!-- Container -->
<div class="container">

  <h2 class="display-3 help-header">
    Adding a new set or catch
  </h2>

  <ul>
    <li class="img-to-text">
      From the main menu in the top right corner below the menu button.
      Use the + button to add a new set.

      <div class="row">
        <!-- main_menu_add_set.png -->
        <img [src]="getImgs[0]"
        class="help-img"
        (click)="showImage(getImgs[0])" />

      </div>
      
    </li>

    <li class="help-ul img-to-text">
      Add set, retrieval and catch details.
      You will need to scroll down to see all of the data fields.
      <ul>
        <li>
          Tap on any field to enter your information
        </li>
        <li>
          Gear will lead you to a pop-up window; see more instructions in the next section
        </li>
        <li>
          Use the red location button to auto-fill the date, time, latitude, and longitude
        </li>
        <li>
          A red check or exclamation point at the bottom of the screen indicates if all fields are complete.
          Required fields will also turn red if they are incomplete.
        </li>
      </ul>

      <div class="row">
        <!-- set_detail_1.png -->
        <img [src]="getImgs[2]"
          class="help-img"
          (click)="showImage(getImgs[2])" />

        <!-- set_detail_2.png -->
        <img [src]="getImgs[3]"
          class="help-img"
          (click)="showImage(getImgs[3])" />
      </div>
      
    </li>
  </ul>

  <h2 class="display-3 help-header">
    Adding and editing gear profiles
  </h2>

  <ul>
    <li>
      "Gear" will open a pop-up window where you use the red + button to enter a new gear type and details.
      Once entered, the gear details will be saved as a group and you can select the same gear profile on future sets.
    </li>
    <li>
      You may enter several gear profiles now, or add new gear profiles as needed for future sets.
    </li>
    <li class="img-to-text">
      The "Delete" button at the bottom of the gear screen can be used to remove gear profiles.
      You will not be allowed to delete a gear profile used for an active set
      (any set that has not been submitted as part of a delivery).

      <div class="row">
        <!-- delete_gear_1.png -->
        <img [src]="getImgs[4]"
          class="help-img"
          (click)="showImage(getImgs[4])" />

        <!-- delete_gear_2.png -->
        <img [src]="getImgs[5]"
          class="help-img"
          (click)="showImage(getImgs[5])" />
      </div>
      

    </li>
  </ul>

  <h2 class="display-3 help-header">
    View existing sets
  </h2>

  <ul>
    <li>
      Return to the set list/main menu with the return arrow or home icon at the top of the screen 
    </li>
    <li class="img-to-text">
      All initiated sets will be displayed with the name given, the set time, and the retrieval time if recorded

      <div class="row">
        <!-- view_set_1.jpg -->
        <img [src]="getImgs[6]"
        class="help-img"
        (click)="showImage(getImgs[6])" />
      </div>
      

    </li>
  </ul>

  <h2 class="display-3 help-header">
    Delete a set
  </h2>

  <ul>
    <li class="img-to-text">
      To delete a set, select the set from the set list.
      Then use the red trash can button in the top right corner to delete the set.

      <div class="row">
        <!-- delete_set_1.png -->
        <img [src]="getImgs[7]"
           class="help-img"
           (click)="showImage(getImgs[7])" />
      </div>

    </li>
  </ul>
</div>
